import React from "react";
import { MessageCircle, Calendar } from "lucide-react";
import { WHATSAPP, CALENDLY } from "@/lib/api";
import { openExternal } from "@/lib/openExternal";

export default function FloatingActions() {
  const waHref = `https://wa.me/${WHATSAPP.replace(/[^0-9]/g, "")}?text=${encodeURIComponent("Hi Tratou Energy, I'd like a quote on MBESS power.")}`;
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3" data-testid="floating-actions">
      <a
        href={waHref}
        target="_blank"
        rel="noreferrer"
        onClick={(e) => openExternal(e, waHref)}
        className="group relative flex items-center gap-3 panel panel-hover px-4 py-3 hover:!border-tratou-green/70"
        data-testid="floating-whatsapp"
      >
        <span className="w-2 h-2 bg-tratou-green animate-pulse-glow rounded-full" />
        <MessageCircle className="w-5 h-5 text-tratou-green" />
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white">WhatsApp</span>
      </a>
      <a
        href={CALENDLY}
        target="_blank"
        rel="noreferrer"
        onClick={(e) => openExternal(e, CALENDLY)}
        className="group relative flex items-center gap-3 panel panel-hover px-4 py-3"
        data-testid="floating-calendly"
      >
        <Calendar className="w-5 h-5 text-tratou-green" />
        <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white">Book Demo</span>
      </a>
    </div>
  );
}
